import React from "react";

import exitIcon from '../../../assets/svgs/hyundai/Button-Close.svg'
import arrowBtnNext from '../../../assets/svgs/hyundai/Button-next.svg'
import arrowBtnPrev from '../../../assets/svgs/hyundai/Button-previus.svg'

import { GalleryData } from "../../../data/gallery.data";

interface GalleryProps {
    car: any,
    isPortrait: boolean,
    showGalleryMenu: boolean,
    setShowGaleryMenu: (boolean: any) => void;
}

const Gallery: React.FC<GalleryProps> = ({ car, isPortrait, showGalleryMenu, setShowGaleryMenu }) => {

  const [gallery, setGallery] = React.useState<any>(null);
  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    const galleryData: any = GalleryData();
    const pictures = [];
    for(const picture of galleryData[car.id]){
        if(picture.active === true){
            pictures.push(picture)
        }
    }
    setGallery(pictures);
    setIndex(0);
  }, [car]);

  const PreviousPicture = () => {
    let nextIndex = index - 1
    if(nextIndex < 0)
      nextIndex = gallery.length - 1;
    setIndex(nextIndex);
  };

  const NextPicture = () => {
    let nextIndex = index + 1
    if(nextIndex > gallery.length - 1)
      nextIndex = 0;
    setIndex(nextIndex);
  };

  return (
    <div className={`gallery-full-container ${showGalleryMenu ? '':'hide'} ${isPortrait ? 'portrait' : ''}`}>
        { gallery && <div className={`gallery-portrait-container ${isPortrait ? 'portrait' : ''}`}>
            <div/>
            <div className={`gallery-portrait-container-pictures`}>
              <img className={`gallery-portrait-container-image ${isPortrait ? 'portrait':''}`} src={gallery[index].image} alt="" />
            </div>
            <div className={`gallery-container-controls ${isPortrait ? 'portrait' : ''}`}>

              <div className={`gallery-container-controls-empty ${isPortrait ? 'portrait' : ''}`}/>
              <img className={`gallery-container-controls-close ${isPortrait ? 'portrait' : ''}`} src={exitIcon} alt='' onClick={() => {setShowGaleryMenu(false)}}/>
              <div className={`gallery-container-controls-navigation`}>
                <div className={`gallery-container-controls-button ${isPortrait ? 'portrait' : ''}`} onClick={() => {PreviousPicture()}}>
                  <img src={arrowBtnPrev} alt=''/>
                </div>
                <div className={`gallery-container-controls-button ${isPortrait ? 'portrait' : ''}`} onClick={() => {NextPicture()}}>
                  <img src={arrowBtnNext} alt=''/>
                </div>
              </div>
            </div>

        </div>
        }
    </div>
  );
};

export default Gallery;
